import { Button, InputEmail } from "@sellar-io/components";
import { useForm } from "@tanstack/react-form";
import { SpinnerLegacy } from "../../components";
import { Alert } from "../../components/alert/Alert";
import { InputLabel, InputContainer } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../components/modal/Dialog";
import { apiV2AssertError } from "../../hooks/api/v2/apiV2Request";
import { useUserInviteCreate } from "../../hooks/api/v2/userInvite/useUserInviteCreate";

export const CustomerContactCreateModal = ({
  active,
  RetailerId,
  onDismiss,
}: {
  active: boolean;
  RetailerId: number;
  onDismiss: () => void;
}) => {
  const contactCreateMutation = useUserInviteCreate();

  const form = useForm({
    defaultValues: {
      email: "",
    },
    validators: {
      onSubmit: ({ value }) =>
        value.email.trim() ? undefined : "Email is required",
    },
    onSubmit: ({ value }) => {
      contactCreateMutation.mutate(
        {
          email: value.email,
          RetailerId,
        },
        {
          onSuccess: () => {
            onDismiss();
          },
        },
      );
    },
  });

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Add new contact"}
      />
      <DialogContent>
        <>
          {contactCreateMutation.isPending ? (
            <SpinnerLegacy />
          ) : (
            <>
              {contactCreateMutation.error && (
                <Alert
                  type={"error"}
                  className={"w-full"}
                  message={
                    apiV2AssertError(contactCreateMutation.error)?.response
                      ?.data.message ?? "Unknown error"
                  }
                />
              )}
              <form
                onSubmit={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  form.handleSubmit();
                }}
                className={"flex flex-col gap-2"}
              >
                <InputLabel>Email</InputLabel>
                <InputContainer>
                  <form.Field name="email">
                    {(field) => (
                      <InputEmail
                        required
                        name={field.name}
                        value={field.state.value}
                        onBlur={field.handleBlur}
                        onChange={(event) =>
                          field.handleChange(event.target.value)
                        }
                      />
                    )}
                  </form.Field>
                </InputContainer>
                <DialogCTA>
                  <Button type="submit">Create contact</Button>
                </DialogCTA>
              </form>
            </>
          )}
        </>
      </DialogContent>
    </Dialog>
  );
};
